// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import binocularIcon from "@/assets/icons/aop/binocular.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type BinocularIconProps = Omit<IconProps, "name">;

export function BinocularIcon(props: BinocularIconProps): React.ReactNode {
  return <Icon name={binocularIcon} {...props} />;
}
